// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2589":"d58c8f4e","3405":"00ada90c","7238":"134be822","9103":"b9ea4917"}[chunkId] + ".css";
};